import { render, staticRenderFns } from "./ShhfBrand.vue?vue&type=template&id=e19ceb08&scoped=true"
import script from "./ShhfBrand.vue?vue&type=script&lang=js"
export * from "./ShhfBrand.vue?vue&type=script&lang=js"
import style0 from "./ShhfBrand.vue?vue&type=style&index=0&id=e19ceb08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e19ceb08",
  null
  
)

export default component.exports